import{jsx as e}from"react/jsx-runtime";import{styled as r}from"styled-components";const i=r.img`
  height: 20px;
  width: 20px;
  min-width: 20px;
  padding: 0px;
  border: 0px;
  border-radius: 10px;
  margin-left: 2px;
  background: url('images/megane_hover.png') 50% 50% repeat-x;

  box-shadow: 1px 1px 2px #888888;
  cursor: ${e=>e.$disabled?"auto":"pointer"};
`;function o({disabled:r=!1,onClick:o,className:a}){return e(i,{src:"images/search.gif",className:a,$disabled:r,onClick:e=>{r||null==o||o(e)}})}export{o as SearchImage};
